"use strict";

require("core-js/modules/es.array.flat");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.reduce-right");

require("core-js/modules/es.array.unscopables.flat");

var _toArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toArray");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveConfig;

var _some = _interopRequireDefault(require("lodash/some"));

var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _defaults = _interopRequireDefault(require("lodash/defaults"));

var _map = _interopRequireDefault(require("lodash/map"));

var _get = _interopRequireDefault(require("lodash/get"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _toPath = _interopRequireDefault(require("lodash/toPath"));

var _head = _interopRequireDefault(require("lodash/head"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _negateValue = _interopRequireDefault(require("./negateValue"));

var _corePluginList = require("../corePluginList");

var _configurePlugins = _interopRequireDefault(require("./configurePlugins"));

var _defaultConfig = _interopRequireDefault(require("../../stubs/defaultConfig.stub"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var configUtils = {
  negative: function negative(scale) {
    return Object.keys(scale).filter(function (key) {
      return scale[key] !== '0';
    }).reduce(function (negativeScale, key) {
      return _objectSpread(_objectSpread({}, negativeScale), {}, _defineProperty({}, "-".concat(key), (0, _negateValue.default)(scale[key])));
    }, {});
  },
  breakpoints: function breakpoints(screens) {
    return Object.keys(screens).filter(function (key) {
      return typeof screens[key] === 'string';
    }).reduce(function (breakpoints, key) {
      return _objectSpread(_objectSpread({}, breakpoints), {}, _defineProperty({}, "screen-".concat(key), screens[key]));
    }, {});
  }
};

function value(valueToResolve) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (0, _isFunction.default)(valueToResolve) ? valueToResolve.apply(void 0, args) : valueToResolve;
}

function collectExtends(items) {
  return items.reduce(function (merged, _ref) {
    var extend = _ref.extend;
    return (0, _mergeWith.default)(merged, extend, function (mergedValue, extendValue) {
      if ((0, _isUndefined.default)(mergedValue)) {
        return [extendValue];
      }

      if (Array.isArray(mergedValue)) {
        return [extendValue].concat(_toConsumableArray(mergedValue));
      }

      return [extendValue, mergedValue];
    });
  }, {});
}

function mergeThemes(themes) {
  return _objectSpread(_objectSpread({}, themes.reduce(function (merged, theme) {
    return (0, _defaults.default)(merged, theme);
  }, {})), {}, {
    // In order to resolve n config objects, we combine all of their `extend` properties
    // into arrays instead of objects so they aren't overridden.
    extend: collectExtends(themes)
  });
}

function mergeExtensionCustomizer(merged, value) {
  // When we have an array of objects, we do want to merge it
  if (Array.isArray(merged) && (0, _isPlainObject.default)((0, _head.default)(merged))) {
    return merged.concat(value);
  } // When the incoming value is an array, and the existing config is an object, prepend the existing object


  if (Array.isArray(value) && (0, _isPlainObject.default)((0, _head.default)(value)) && (0, _isPlainObject.default)(merged)) {
    return [merged].concat(_toConsumableArray(value));
  } // Override arrays (for example for font-families, box-shadows, ...)


  if (Array.isArray(value)) {
    return value;
  } // Execute default behaviour


  return undefined;
}

function mergeExtensions(_ref2) {
  var extend = _ref2.extend,
      theme = _objectWithoutProperties(_ref2, ["extend"]);

  return (0, _mergeWith.default)(theme, extend, function (themeValue, extensions) {
    // The `extend` property is an array, so we need to check if it contains any functions
    if (!(0, _isFunction.default)(themeValue) && !(0, _some.default)(extensions, _isFunction.default)) {
      return (0, _mergeWith.default).apply(void 0, [{}, themeValue].concat(_toConsumableArray(extensions), [mergeExtensionCustomizer]));
    }

    return function (resolveThemePath, utils) {
      return (0, _mergeWith.default).apply(void 0, [{}].concat(_toConsumableArray([themeValue].concat(_toConsumableArray(extensions)).map(function (e) {
        return value(e, resolveThemePath, utils);
      })), [mergeExtensionCustomizer]));
    };
  });
}

function resolveFunctionKeys(object) {
  var resolvePath = function resolvePath(key, defaultValue) {
    var path = (0, _toPath.default)(key);
    var index = 0;
    var val = object;

    while (val !== undefined && val !== null && index < path.length) {
      val = val[path[index++]];
      val = (0, _isFunction.default)(val) ? val(resolvePath, configUtils) : val;
    }

    return val === undefined ? defaultValue : val;
  };

  return Object.keys(object).reduce(function (resolved, key) {
    return _objectSpread(_objectSpread({}, resolved), {}, _defineProperty({}, key, (0, _isFunction.default)(object[key]) ? object[key](resolvePath, configUtils) : object[key]));
  }, {});
}

function extractPluginConfigs(configs) {
  var allConfigs = [];
  configs.forEach(function (config) {
    allConfigs = [].concat(_toConsumableArray(allConfigs), [config]);
    var plugins = (0, _get.default)(config, 'plugins', []);

    if (plugins.length === 0) {
      return;
    }

    plugins.forEach(function (plugin) {
      if (plugin.__isOptionsFunction) {
        plugin = plugin();
      }

      allConfigs = [].concat(_toConsumableArray(allConfigs), _toConsumableArray(extractPluginConfigs([(0, _get.default)(plugin, 'config', {})])));
    });
  });
  return allConfigs;
}

function mergeVariants(variants) {
  var mergedVariants = variants.reduce(function (resolved, variants) {
    Object.entries(variants || {}).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          plugin = _ref4[0],
          pluginVariants = _ref4[1];

      if ((0, _isFunction.default)(pluginVariants)) {
        resolved[plugin] = pluginVariants({
          variants: function variants(path) {
            return (0, _get.default)(resolved, path, []);
          },
          before: function before(toInsert, variant) {
            var existingPluginVariants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _get.default)(resolved, plugin, []);

            if (variant === undefined) {
              return [].concat(_toConsumableArray(toInsert), _toConsumableArray(existingPluginVariants));
            }

            var index = existingPluginVariants.indexOf(variant);

            if (index === -1) {
              return [].concat(_toConsumableArray(existingPluginVariants), _toConsumableArray(toInsert));
            }

            return [].concat(_toConsumableArray(existingPluginVariants.slice(0, index)), _toConsumableArray(toInsert), _toConsumableArray(existingPluginVariants.slice(index)));
          },
          after: function after(toInsert, variant) {
            var existingPluginVariants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _get.default)(resolved, plugin, []);

            if (variant === undefined) {
              return [].concat(_toConsumableArray(existingPluginVariants), _toConsumableArray(toInsert));
            }

            var index = existingPluginVariants.indexOf(variant);

            if (index === -1) {
              return [].concat(_toConsumableArray(toInsert), _toConsumableArray(existingPluginVariants));
            }

            return [].concat(_toConsumableArray(existingPluginVariants.slice(0, index + 1)), _toConsumableArray(toInsert), _toConsumableArray(existingPluginVariants.slice(index + 1)));
          },
          without: function without(toRemove) {
            var existingPluginVariants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _get.default)(resolved, plugin, []);
            return existingPluginVariants.filter(function (v) {
              return !toRemove.includes(v);
            });
          }
        });
      } else {
        resolved[plugin] = pluginVariants;
      }
    });
    return resolved;
  }, {});
  return _objectSpread(_objectSpread({}, mergedVariants), {}, {
    extend: collectExtends(variants)
  });
}

function mergeVariantExtensions(_ref5, variantOrder) {
  var extend = _ref5.extend,
      variants = _objectWithoutProperties(_ref5, ["extend"]);

  return (0, _mergeWith.default)(variants, extend, function (variantsValue, extensions) {
    var merged = (0, _uniq.default)([].concat(_toConsumableArray(variantsValue), _toConsumableArray(extensions)).flat());

    if (extensions.flat().length === 0) {
      return merged;
    }

    return merged.sort(function (a, z) {
      return variantOrder.indexOf(a) - variantOrder.indexOf(z);
    });
  });
}

function resolveVariants(_ref6, variantOrder) {
  var _ref7 = _toArray(_ref6),
      firstConfig = _ref7[0],
      variantConfigs = _ref7.slice(1);

  // Global variants configuration like `variants: ['hover', 'focus']`
  if (Array.isArray(firstConfig)) {
    return firstConfig;
  }

  return mergeVariantExtensions(mergeVariants([firstConfig].concat(_toConsumableArray(variantConfigs)).reverse()), variantOrder);
}

function resolveCorePlugins(corePluginConfigs) {
  var result = _toConsumableArray(corePluginConfigs).reduceRight(function (resolved, corePluginConfig) {
    if ((0, _isFunction.default)(corePluginConfig)) {
      return corePluginConfig({
        corePlugins: resolved
      });
    }

    return (0, _configurePlugins.default)(corePluginConfig, resolved);
  }, _corePluginList.corePluginList);

  return result;
}

function resolvePluginLists(pluginLists) {
  var result = _toConsumableArray(pluginLists).reduceRight(function (resolved, pluginList) {
    return [].concat(_toConsumableArray(resolved), _toConsumableArray(pluginList));
  }, []);

  return result;
}

function resolveConfig(configs) {
  var allConfigs = [].concat(_toConsumableArray(extractPluginConfigs(configs)), [{
    darkMode: false,
    prefix: '',
    important: false,
    separator: ':',
    variantOrder: _defaultConfig.default.variantOrder
  }]);

  var _allConfigs$find = allConfigs.find(function (c) {
    return c.variantOrder;
  }),
      variantOrder = _allConfigs$find.variantOrder;

  return (0, _defaults.default).apply(void 0, [{
    theme: resolveFunctionKeys(mergeExtensions(mergeThemes((0, _map.default)(allConfigs, function (t) {
      return (0, _get.default)(t, 'theme', {});
    })))),
    variants: resolveVariants(allConfigs.map(function (c) {
      return (0, _get.default)(c, 'variants', {});
    }), variantOrder),
    corePlugins: resolveCorePlugins(allConfigs.map(function (c) {
      return c.corePlugins;
    })),
    plugins: resolvePluginLists(configs.map(function (c) {
      return (0, _get.default)(c, 'plugins', []);
    }))
  }].concat(_toConsumableArray(allConfigs)));
}